<template>
    <div>
        <div v-if="isSuper" class="comment__badge-wrap">
            <div class="comment__badge">Главный эксперт</div>
        </div>
        <div class="comment">
            <div>
                <Avatar />
            </div>
            <div class="comment__right-column">
                <div class="comment__title">Комментарий</div>
                <div>
                    <textarea v-model="comment" class="comment__textarea" rows="10" :readonly="readonly" />
                </div>
                <div v-if="!readonly" class="comment__buttons">
                    <RsvButton
                        :loading="saving"
                        color="blue"
                        text="Сохранить"
                        @click="save(false)"
                    />
                    <RsvButton
                        :loading="saving"
                        :disabled="!completed"
                        color="blue"
                        text="Завершить проверку"
                        @click="showConfirm = true"
                    />
                </div>
            </div>
        </div>

        <Dialog class="confirm-dialog" :is-popup="showConfirm" @close="showConfirm = false">
            <div class="confirm-dialog__title">
                Вы уверены, что хотите завершить проверку?
            </div>
            <div class="confirm-dialog__footer">
                <RsvButton color="blue" text="Завершить" @click="save(true)" />
                <RsvButton color="white" text="Отмена" @click="showConfirm = false" />
            </div>
        </Dialog>
    </div>
</template>

<script>
import Avatar from "@/components/header/Avatar.vue";
import RsvButton from "@/components/UI/RsvButton/RsvButton.vue";
import Dialog from "@/components/UI/Dialog.vue";

export default {
    name: "ExpertPanelReviewAssessmentCommentForm",
    components: {Avatar, RsvButton, Dialog},
    props: {
        isSuper: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Object,
            default: () => ({
                comment: '',
            }),
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        saving: {
            type: Boolean,
            default: false,
        },
        completed: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            comment: this.value ? this.value.comment : '',
            showConfirm: false,
        };
    },
    methods: {
        save(finish) {
            this.showConfirm = false;
            this.$emit('input', {comment: this.comment, finish});
            this.$emit('submit', false);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.comment {
  display: flex;
  width: 100%;
  gap: rem(16);

  &__badge {
    display: inline-block;
    text-align: right;
    padding: rem(4) rem(12);
    background: #4663AB;
    border-radius: rem(20);
    font-weight: 700;
    font-size: rem(16);
    line-height: rem(24);
    color: #FFFFFF;
    &-wrap {
      text-align: right;
    }
  }

  &__right-column {
    flex: 1;
  }

  &__title {
    font-weight: 600;
    font-size: rem(16);
    line-height: rem(22);
    color: #2A2626;
    margin-bottom: rem(6);
  }

  &__textarea {
    font-family: Montserrat, sans-serif;
    width: 100%;
    background: #F9F9FA;
    border-radius: rem(16);
    border: 0;
    padding: rem(16);
    resize: vertical;
    font-size: rem(16);

    font-weight: 400;
    line-height: rem(22);
    color: #2A2626;
  }

  &__buttons {
    display: flex;
    margin-top: rem(24);
    gap: rem(16);

    .rsv-button_color_blue {
      font-family: Montserrat, sans-serif;
      padding: rem(14) rem(32);
      background: #4663AB;
      border-radius: rem(10);
      font-weight: 600;
      font-size: rem(14);
      line-height: rem(20);
      color: #FFFFFF;
    }
  }

  .avatar {
    width: rem(48);
    height: rem(48);
    border-width: 2px;

    :deep(img) {
      width: 100%;
      height: 100%;
      border: solid 2px #fff;
    }
  }
}
.confirm-dialog {
  :deep(.dialog) {
    max-width: rem(680);
  }
  &__title {
    font-family: Montserrat, sans-serif;
    font-weight: 600;
    font-size: rem(20);
    line-height: rem(30);
    text-align: center;
    color: #000000;
    margin-top: rem(16);
    margin-bottom: rem(16);
  }
  &__footer {
    display: flex;
    justify-content: center;
    gap: rem(22);
    :deep(.rsv-button_color_white) {
      padding: rem(14) rem(32);
      background: #fff;
      border: solid 1px #4663AB;
      color: #4663ab;
      border-radius: rem(10);
    }
  }
}
</style>